import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { MusterChitReportSchema } from "../MusterChitReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './CreatePdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './MTable.css';
import _, { forEach } from 'lodash';
import moment from 'moment';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import MessageModal from "../../../../UI/Modal/MessageModal";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Search } from '@material-ui/icons';
import InputAdornment from '@material-ui/core/InputAdornment';
import Box from '@material-ui/core/Box';

const screenCode = "MUSTERCHITREPORT";
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function MusterChitReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [gtnnumber, setGtnnumber] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [totalAmount, setTotalAmount] = useState();
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [usersList, setUsersList] = useState("");
    const [chipData, setChipData] = useState([]);

    const [musterChitReport, setMusterChitReport] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        jobTypeID: 0,
        searchDate: new Date().toISOString().split('T')[0],
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        jobTypeID: 0,
        searchDate: "",
    })

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "",
        disciption: "",
    });

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(MusterChitReportSchema).options({ allowUnknown: true });
    const contentRowNames = ["jobTypeName", "employeeID", "employeeName", "taskName", "fieldName", "subFieldName", "assignAt", "startedAt", "completedTime"];
    const csvHeaders = [
        { label: "Job Type", value: "jobTypeName" },
        { label: "Registration Number", value: "employeeID" },
        { label: "Employee Name", value: "employeeName" },
        { label: "Task Name", value: "taskName" },
        { label: "Field No.", value: "fieldName" },
        { label: "Sub Field No.", value: "subFieldName" },
        { label: "Started (Date/Time)", value: "startedAt" },
        { label: "Completed (Date/Time)", value: "completedTime" },
        { label: "Duration (Hours)", value: "durationFormatted" },
    ];

    const [reportData, setReportData] = useState([]);
    const [reportDataOne, setReportDataOne] = useState([]);
    const [keys, setKeys] = useState([]);

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };
    const [customSearch, setCustomSearch] = useState({ regNumber: '' });
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        if (reportData.length > 0 && !isTableHide) {
            handleCustomSearch(customSearch.regNumber);
        }
    }, [customSearch.regNumber]);

    useEffect(() => {
        setReportData([])
        setIsTableHide(true)
    }, [musterChitReport.divisionID]);

    useEffect(() => {
        setReportData([])
        setIsTableHide(true)
    }, [musterChitReport.estateID]);

    useEffect(() => {
        setReportData([])
        setIsTableHide(true)
    }, [musterChitReport.searchDate, musterChitReport.jobTypeID]);

    useEffect(() => {
        setLimit(10);
        setPage(0);
    }, [musterChitReport.divisionID]);

    useEffect(() => {
        setLimit(10);
        setPage(0);
    }, [musterChitReport.estateID]);

    useEffect(() => {
        setLimit(10);
        setPage(0);
    }, [musterChitReport.searchDate]);


    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown(),
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),

        )
    }, [musterChitReport.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
        )
    }, [musterChitReport.estateID])

    useEffect(() => {
        trackPromise(
            getGtnNumberForDropDown()
        )
    }, [musterChitReport.searchDate])

    useEffect(() => {
    }, [reportData]);

    function handleCustomSearch(searchValue) {
        if (!searchValue || searchValue === '') {
            setFilteredData(flattenedData);
        } else {
            const filtered = flattenedData.filter(row => {
                return (
                    row.employeeID?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    row.employeeName?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    row.taskName?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    row.fieldName?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    row.subFieldName?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    row.jobTypeGroup?.toLowerCase().includes(searchValue.toLowerCase())
                );
            });
            setFilteredData(filtered);
        }
    }

    function handleChange1(e) {
        setCustomSearch({
            ...customSearch,
            regNumber: e.target.value
        });
    }

    function clearTable() {
        setIsTableHide(true);
        setIsReportButtonsEnabled(false);
        setReportData([]);
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setMusterChitReport({
            ...musterChitReport,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            jobTypeID: 0,
            searchDate: new Date().toISOString().split('T')[0],

        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setMusterChitReport({
            ...musterChitReport,
            estateID: target.value,
            divisionID: "0",
            jobTypeID: 0,
            searchDate: new Date().toISOString().split('T')[0],

        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setMusterChitReport({
            ...musterChitReport,
            divisionID: target.value,
            jobTypeID: 0,
            searchDate: new Date().toISOString().split('T')[0],

        });
    }

    function handleJobTypeChange(target) {
        setMusterChitReport({
            ...musterChitReport,
            jobTypeID: parseInt(target.value),
        });
    }

    function handleSearchDateChange(target) {
        validateInputs(target);

        setMusterChitReport({
            ...musterChitReport,
            searchDate: target.value

        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, MusterChitReportSchema);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBLOCKWEIGHTMENTREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromTokenV2();

        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setMusterChitReport({
                ...musterChitReport,
                groupID: token.groupID
            });

        } else {
            setMusterChitReport({
                ...musterChitReport,
                groupID: token.groupID,
                estateID: token.operationEntityID
            });
        }
        setMusterChitReport({
            ...musterChitReport,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }
    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWMUSTERCHITREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromTokenV2();

        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setMusterChitReport({
                ...musterChitReport,
                groupID: token.groupID
            });

        } else {
            setMusterChitReport({
                ...musterChitReport,
                groupID: token.groupID,
                estateID: token.operationEntityID
            });
        }

        setMusterChitReport({
            ...musterChitReport,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(musterChitReport.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(musterChitReport.estateID);
        setDivisions(data);
    }

    async function getGtnNumberForDropDown() {
        const data = await services.getGtnNumberByCollectionPointIDandDate(musterChitReport);
        setGtnnumber(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }



    async function handleSearch(e) {
        const errorMessages = validate(schema, musterChitReport);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        e.preventDefault();
        setIsTableHide(true);
        setButtonHide(true);
        getSelectedDropdownValuesForReport(musterChitReport);
        setIsTableHide(true);
        setCustomSearch({ regNumber: '' });
        const result = await services.GetMusterChitReportData(musterChitReport);
        let groupedResult = groupByGtn(result);
        let keys = Object.keys(groupedResult);
        setKeys(keys);
        // Add job type name to each record for export
        const resultWithJobType = result.map(row => {
            const jobTypeName = row.jobTypeID == 1 ? 'General' : row.jobTypeID == 2 ? 'Cash' : row.jobTypeID == 3 ? 'OT' : row.jobTypeID == 99 ? 'PLK' : 'Unknown';
            const durationCalc = calculateDuration(row.startedAt, row.completedTime);

            return {
                ...row,
                jobTypeName: jobTypeName,
                durationFormatted: durationCalc.duration,
                durationHours: durationCalc.hours
            };
        });
        setReportData(resultWithJobType);
        setReportDataOne(groupedResult);
        let count = [];
        {
            Object.entries(_.groupBy(result, "taskName")).map(([taskName, rows]) => (
                count.push({ taskName: taskName, count: rows.length })
            ))
        }
        setChipData(count);
        const userNames = []
        if (result.length > 0) {
            result.forEach(x => {
                x.assignAt = x.assignAt == null ? '-' : moment(x.assignAt).format('MM/DD/YYYY h:mm:ss a');
                x.startedAt = x.startedAt == null ? '-' : moment(x.startedAt).format('MM/DD/YYYY h:mm:ss a');
                x.completedTime = x.completedTime == null ? '-' : moment(x.completedTime).format('MM/DD/YYYY h:mm:ss a');
                userNames.push(x.userName);
            })
            var uniq = userNames.reduce(function (a, b) {
                if (a.indexOf(b) < 0) a.push(b);
                return a;
            }, []);
            const namesList = uniq.join();
            setUsersList(namesList);
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Error",
                disciption: "No Records To Display",
            });
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
        setButtonHide(false);
        setIsReportButtonsEnabled();
        const comlpeteData = [...resultWithJobType];
        setCsvData(comlpeteData)
    }

    function createFile() {
        var settings = {
            sheetName: 'Muster Chit Report',
            fileName: 'MusterChitReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)

        copyOfCsv.push({}, { jobTypeName: "Task-Wise Job Type Count" })
        Object.entries(_.groupBy(csvData, "taskName")).forEach(([taskName, taskRows]) => {
            const jobTypeCounts = _.groupBy(taskRows, "jobTypeName");
            const jobTypeCountsText = Object.entries(jobTypeCounts)
                .sort(([jobTypeA], [jobTypeB]) => {
                    const order = { 'General': 1, 'Cash': 2, 'OT': 3, 'PLK': 99 };
                    return (order[jobTypeA] || 999) - (order[jobTypeB] || 999);
                })
                .map(([jobType, rows]) => `${jobType} - ${rows.length}`)
                .join(' / ');

            var dataCopy = {
                jobTypeName: taskName + " : ",
                employeeID: jobTypeCountsText
            };
            copyOfCsv.push(dataCopy)
        });

        var newRow1 = {
            jobTypeName: "Group : " + groups[musterChitReport.groupID],
            employeeID: "Collection Point : " + divisions[musterChitReport.divisionID],
            employeeName: "Operation Entity : " + estates[musterChitReport.estateID]
        }
        copyOfCsv.push({}, newRow1)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            date: searchForm.searchDate
        })
    }

    function groupByGtn(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['gtnNumber'] ? obj['gtnNumber'] : 'unknown';
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }

    const groupedByJobType = Object.entries(_.groupBy(reportData, "jobTypeID"))
        .map(([jobTypeID, jobTypeRows]) => ({
            jobTypeID: parseInt(jobTypeID),
            jobTypeName: jobTypeID == 1 ? 'General' : jobTypeID == 2 ? 'Cash' : jobTypeID == 3 ? 'OT' : jobTypeID == 99 ? 'PLK' : 'Unknown',
            taskGroups: Object.entries(_.groupBy(jobTypeRows, "taskName"))
                .sort((a, b) => {
                    const aDate = a[1][0]?.assignAt ? new Date(a[1][0].assignAt) : new Date(0);
                    const bDate = b[1][0]?.assignAt ? new Date(b[1][0].assignAt) : new Date(0);
                    return aDate - bDate;
                })
        }))
        .sort((a, b) => a.jobTypeID - b.jobTypeID);

    const flattenedData = [];
    groupedByJobType.forEach(jobTypeGroup => {
        jobTypeGroup.taskGroups.forEach(([taskName, rows]) => {
            rows.forEach(row => {
                flattenedData.push({
                    ...row,
                    jobTypeGroup: jobTypeGroup.jobTypeName,
                    taskName
                });
            });
        });
    });

    const dataToDisplay = customSearch.regNumber && customSearch.regNumber !== ''
        ? flattenedData.filter(row => {
            return (
                row.employeeID?.toLowerCase().includes(customSearch.regNumber.toLowerCase()) ||
                row.employeeName?.toLowerCase().includes(customSearch.regNumber.toLowerCase()) ||
                row.taskName?.toLowerCase().includes(customSearch.regNumber.toLowerCase()) ||
                row.fieldName?.toLowerCase().includes(customSearch.regNumber.toLowerCase()) ||
                row.subFieldName?.toLowerCase().includes(customSearch.regNumber.toLowerCase()) ||
                row.jobTypeGroup?.toLowerCase().includes(customSearch.regNumber.toLowerCase())
            );
        })
        : flattenedData;

    const totalRows = dataToDisplay.length;
    const startIndex = page * limit;
    const endIndex = startIndex + limit;

    const paginatedData = dataToDisplay.slice(startIndex, endIndex);

    const displayGroups = [];
    const processedJobTypes = new Set();

    paginatedData.forEach(row => {
        const jobTypeKey = row.jobTypeGroup;
        if (!processedJobTypes.has(jobTypeKey)) {
            const jobTypeRows = paginatedData.filter(r => r.jobTypeGroup === jobTypeKey);
            displayGroups.push({
                jobTypeName: jobTypeKey,
                rows: jobTypeRows,
                rowSpan: jobTypeRows.length
            });
            processedJobTypes.add(jobTypeKey);
        }
    });

    function calculateDuration(startedAt, completedTime) {
        if (!startedAt || !completedTime || startedAt === '-' || completedTime === '-') {
            return { duration: '-', hours: 0 };
        }

        const start = moment(startedAt);
        const end = moment(completedTime);
        const durationMs = end.diff(start);
        const hours = durationMs / (1000 * 60 * 60);

        const duration = moment.duration(durationMs);
        const formattedDuration = `${Math.floor(duration.asHours())}:${String(duration.minutes()).padStart(2, '0')}`;

        return { duration: formattedDuration, hours: hours };
    }

    function isGeneralTaskStartAfter10AM(jobTypeName, startedAt) {
        if (jobTypeName !== 'General' || !startedAt || startedAt === '-') {
            return false;
        }

        const startTime = moment(startedAt);
        const tenAM = moment(startedAt).set({ hour: 10, minute: 0, second: 0 });

        return startTime.isAfter(tenAM);
    }
    function clearData() {
        setMusterChitReport({
            ...musterChitReport,
            // estateID: "0",
            divisionID: "0",
            jobTypeID: 0,
            searchDate: "",
        });
        setSelectedSearchValues({
            ...selectedSearchValues,
            division: "0",
            jobTypeID: 0,
            searchDate: "",
        });
        setErrors({});
        clearTable();
        setButtonHide(true);
        setUsersList("");
        setChipData([]);
        setGtnnumber([]);
        setReportData([]);
        setIsTableHide(true);
        setCustomSearch({ regNumber: '' });
        trackPromise(getDivisionsForDropDown());
    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Muster Chit Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={musterChitReport.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md-4">
                                        <InputLabel shrink id="estateID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={musterChitReport.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={musterChitReport.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4 ">
                                        <InputLabel shrink id="">Job Type</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="jobTypeID"
                                            id="jobTypeID"
                                            name="jobTypeID"
                                            value={musterChitReport.jobTypeID}
                                            onChange={(e) => handleJobTypeChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Job Type--</MenuItem>
                                            <MenuItem value="1">General</MenuItem>
                                            <MenuItem value="2">Cash</MenuItem>
                                            <MenuItem value="3">OT</MenuItem>
                                            <MenuItem value="99">PLK</MenuItem>

                                        </Select>
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            value={musterChitReport.searchDate}
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>

                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                    <input
                                        type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={() => clearData()}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="pt-3">
                                        <h6 className="text-left">Task-Wise Job Type Count</h6>
                                        <div className="chip-container">
                                            <Stack
                                                direction="row"
                                                spacing={1}
                                                style={{
                                                    marginBottom: '10px',
                                                    flexWrap: 'wrap',
                                                    gap: '8px'
                                                }}
                                            >
                                                {Object.entries(_.groupBy(reportData, "taskName")).map(([taskName, taskRows]) => {
                                                    const jobTypeCounts = _.groupBy(taskRows, "jobTypeName");
                                                    const jobTypeCountsText = Object.entries(jobTypeCounts)
                                                        .sort(([jobTypeA], [jobTypeB]) => {
                                                            const order = { 'General': 1, 'Cash': 2, 'OT': 3, 'PLK': 99 };
                                                            return (order[jobTypeA] || 999) - (order[jobTypeB] || 999);
                                                        })
                                                        .map(([jobType, rows]) => `${jobType} - ${rows.length}`)
                                                        .join(' / ');

                                                    return (
                                                        <Chip
                                                            key={taskName}
                                                            label={`${taskName} : ${jobTypeCountsText}`}
                                                            variant="outlined"
                                                            sx={{
                                                                borderColor: "limegreen",
                                                                color: "limegreen",
                                                                fontWeight: "bold",
                                                                marginBottom: '8px'
                                                            }}
                                                        />
                                                    );
                                                })}
                                            </Stack>
                                        </div>
                                    </div>
                                    <div className="pt-3 pb-2">
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            gap: '16px',
                                            padding: '12px 16px',
                                            backgroundColor: '#f8f9fa',
                                            borderRadius: '8px',
                                            border: '1px solid #e0e0e0',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1 }}>
                                                <span style={{
                                                    fontWeight: '600',
                                                    color: '#424242',
                                                    fontSize: '14px',
                                                    marginRight: '8px'
                                                }}>
                                                    Legend:
                                                </span>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div style={{
                                                        width: '24px',
                                                        height: '24px',
                                                        backgroundColor: '#fff9c4',
                                                        marginRight: '8px',
                                                        borderRadius: '4px',
                                                        border: '1px solid #fdd835',
                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                    }}></div>
                                                    <span style={{
                                                        fontSize: '13px',
                                                        color: '#616161',
                                                        fontWeight: '500'
                                                    }}>
                                                        Duration &lt; 4 hours
                                                    </span>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div style={{
                                                        width: '24px',
                                                        height: '24px',
                                                        backgroundColor: '#ffe5e5',
                                                        marginRight: '8px',
                                                        borderRadius: '4px',
                                                        border: '1px solid #ef9a9a',
                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                    }}></div>
                                                    <span style={{
                                                        fontSize: '13px',
                                                        color: '#616161',
                                                        fontWeight: '500'
                                                    }}>
                                                        General Tasks Start After 10 a.m.
                                                    </span>
                                                </div>
                                            </div>

                                            <Box>
                                                <TextField
                                                    size="small"
                                                    style={{ width: '300px', backgroundColor: 'white' }}
                                                    value={customSearch.regNumber}
                                                    placeholder="Search"
                                                    onChange={(e) => { handleChange1(e) }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Search />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Box>
                                        </div>
                                    </div>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Job Type</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Registration Number</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Name</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Task Name</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Field No.</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Sub Field No.</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Started (Date/Time)</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Completed (Date/Time)</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Duration (Hours)</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {displayGroups.map((jobTypeGroup, groupIdx) => (
                                                    <React.Fragment key={groupIdx}>
                                                        {jobTypeGroup.rows.map((row, rowIdx) => {
                                                            const isRedRow = isGeneralTaskStartAfter10AM(row.jobTypeGroup, row.startedAt);
                                                            const isDurationYellow = row.jobTypeGroup === 'General' && row.durationHours >= 0 && row.durationHours < 4 && row.compliation === 100 && row.taskName?.toLowerCase() !== 'xpr';

                                                            return (
                                                                <TableRow
                                                                    key={`${groupIdx}-${rowIdx}`}
                                                                    style={{ backgroundColor: isRedRow ? '#ffe5e5' : 'transparent' }}
                                                                >
                                                                    {rowIdx === 0 && (
                                                                        <TableCell
                                                                            component="th"
                                                                            scope="row"
                                                                            align="center"
                                                                            rowSpan={jobTypeGroup.rowSpan}
                                                                            style={{
                                                                                fontWeight: "bold",
                                                                                backgroundColor: "#f5f5f5",
                                                                                verticalAlign: "middle"
                                                                            }}
                                                                        >
                                                                            {jobTypeGroup.jobTypeName}
                                                                        </TableCell>
                                                                    )}
                                                                    <TableCell component="th" scope="row" align="left">{row.employeeID}</TableCell>
                                                                    <TableCell component="th" scope="row" align="left">{row.employeeName}</TableCell>
                                                                    <TableCell component="th" scope="row" align="left">{row.taskName}</TableCell>
                                                                    <TableCell component="th" scope="row" align="left">{row.fieldName}</TableCell>
                                                                    <TableCell component="th" scope="row" align="left">{row.subFieldName}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center">
                                                                        {row.startedAt?.replace("T", " ")}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" align="center">
                                                                        {row.completedTime?.replace("T", " ")}
                                                                    </TableCell>
                                                                    <TableCell
                                                                        component="th"
                                                                        scope="row"
                                                                        align="center"
                                                                        style={{
                                                                            backgroundColor: isDurationYellow ? '#fff9c4' : 'transparent',
                                                                            fontWeight: isDurationYellow ? 'bold' : 'normal'
                                                                        }}
                                                                    >
                                                                        {row.durationFormatted}
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </React.Fragment>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            component="div"
                                            count={totalRows}
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handleLimitChange}
                                            page={page}
                                            rowsPerPage={limit}
                                            rowsPerPageOptions={[5, 10, 25]}
                                        />
                                    </TableContainer>
                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                        <ReactToPrint
                                            documentTitle={"Muster Chit Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"
                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} dataOne={reportDataOne} flattenedData={flattenedData}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} keys={keys} totalAmount={totalAmount} usersList={usersList} chipData={chipData} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}


